import { moreRelatedContentText } from './getSeeMoreButton.locstring.json';
import loc, { format } from 'owa-localize';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import * as React from 'react';
import { Link } from '@fluentui/react/lib/Link';
import generateLinkStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateLinkStyle';

import styles from './SeeMoreButton.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export default function getSeeMoreButton(
    numberToSeeMore: number,
    colorScheme: ColorScheme,
    onClick: () => void,
    customRootClassname: string,
    marginRight: number
): JSX.Element {
    return (
        <Link
            onClick={onClick}
            className={classNames(styles.seeMoreButton, customRootClassname)}
            style={{ marginRight: marginRight }}
            styles={generateLinkStyle(colorScheme)}>
            {format(loc(moreRelatedContentText), numberToSeeMore)}
            <Icon iconName={ControlIcons.ChevronDown} className={styles.downChevron} />
        </Link>
    );
}
